import { Fragment } from 'react'
import className from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { isNil } from 'lodash'
import { useTranslation } from 'react-i18next'

import { selectIsLoggedIn } from 'store/selectors'
import { toggleJoinGroupBeforeActionConfirmBox } from 'store/actions/confirmBox'
import { endpoints } from 'store/api/yay/group'
import { useCurrentUser } from 'store/api/yay/user'
import { Post } from 'lib/_types'

import './style.scss'

const PostSurvey = ({ post, onVote }: { post: Post; onVote?: Function }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { data: currentUser } = useCurrentUser()
  const isLoggedIn = useSelector(selectIsLoggedIn)

  const groupId = post?.group_id?.toString?.()
  const groupRes = endpoints?.getGroup?.useQueryState?.(
    {
      groupId,
    },
    {
      skip: isNil(groupId),
    }
  )

  if (isNil(post?.survey)) {
    return null
  }

  return (
    <div className="PostSurvey">
      {post?.user?.id == currentUser?.id ||
      post?.survey?.voted ||
      !isLoggedIn ? (
        <dl className="PostSurvey__dl">
          {(post?.survey?.choices ?? [])?.map?.((y, j) => (
            <Fragment key={j}>
              {(() => {
                const totalVotes =
                  (post?.survey?.votes_count || 0) == 0
                    ? 1
                    : post?.survey?.votes_count

                const votePercent = Math.round(
                  (y?.votes_count / totalVotes) * 100
                )

                return (
                  <div
                    className={className('PostSurvey__dl__item', {
                      'PostSurvey__dl__item--active': y?.votes_count > 0,
                    })}
                  >
                    <span
                      className="PostSurvey__dl__item__bar"
                      style={{
                        width: `${votePercent}%`,
                      }}
                    />

                    <dt>{y?.label}</dt>
                    <dd>{votePercent}%</dd>
                  </div>
                )
              })()}
            </Fragment>
          ))}
        </dl>
      ) : (
        <ul className="PostSurvey__ul">
          {(post?.survey?.choices ?? []).map((y, j) => (
            <li key={j}>
              <a
                className="PostSurvey__ul__a"
                onClick={() => {
                  if (!isNil(groupId) && !groupRes?.data?.is_joined) {
                    dispatch(
                      toggleJoinGroupBeforeActionConfirmBox(
                        groupRes?.data?.id?.toString?.()
                      )
                    )

                    return
                  }

                  onVote({
                    post,
                    choiceId: y?.id,
                  })
                }}
              >
                {y?.label}
              </a>
            </li>
          ))}
        </ul>
      )}

      {post?.survey?.votes_count > 0 && (
        <p className="PostSurvey__p">
          {t('post.post_survey.vote_count', {
            votes: post?.survey?.votes_count,
          })}
        </p>
      )}
    </div>
  )
}

export default PostSurvey
